module.exports = __webpack_public_path__ + "img/price_en.07a6bf85.svg";